import { Integration_Auth_Names_Enum, Integration_Names_Enum } from '@main/graphql/types.generated';
import { z } from 'zod/v4';
import { $ZodLooseShape } from 'zod/v4/core';

import { IntegrationAuth, IntegrationConnector, IntegrationConnectorCategory } from '../../lib';

export type SharepointConnectorConfig = typeof SharepointConnector._.Config;

export const SharepointConnector = IntegrationConnector.make({
  provider: Integration_Names_Enum.Sharepoint,
  logoPath: 'images/sharepoint-logo.svg',
  categories: [IntegrationConnectorCategory.Productivity],
  auths: IntegrationAuth.group([
    IntegrationAuth.app({
      name: Integration_Auth_Names_Enum.App,
      clientId: (config) => config.sharepoint.clientId,
      installUrl: 'https://login.microsoftonline.com/organizations/v2.0/adminconsent',
      scope: 'https://graph.microsoft.com/.default',
      configSchema: z.object({
        tenantId: z.uuid(),
      }),
      // Widen the inferred type without allowing undeclared encrypted fields at runtime (z.looseObject).
      encryptedConfigSchema: z.object({}) as z.ZodObject<$ZodLooseShape>,
      userConfigSchema: {
        configSchema: z.object({}),
        encryptedConfigSchema: z.object({}),
      },
      getConfigFromCallback(req) {
        const { tenant: tenantId } = z.object({ tenant: z.uuid() }).parse(req.query);
        return {
          config: { tenantId },
        };
      },
    }),
  ]),
});
